// client/src/hooks/useManagers.js
// CRUD hooks for the camp managers nested resource.

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

const managersKey = (campId) => ['camps', campId, 'managers'];

export function useManagers(campId) {
  return useQuery({
    queryKey: managersKey(campId),
    queryFn: () => api.get(`/api/camps/${campId}/managers`).then((r) => r.managers),
    enabled: !!campId,
  });
}

export function useInviteManager(campId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email) => api.post(`/api/camps/${campId}/managers`, { email }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: managersKey(campId) });
    },
  });
}

export function useRemoveManager(campId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId) => api.delete(`/api/camps/${campId}/managers/${userId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: managersKey(campId) });
    },
  });
}
